import { friendApis } from '@apis/friendApis';
import { useMutation } from '@hooks/useMutation';
import { PatchFriendInvitation } from '@models/Friend';
import { useQueryClient } from '@tanstack/react-query';

export const usePatchFriendInvited = (id: number) => {
  const queryClient = useQueryClient();

  return useMutation(
    async (body: PatchFriendInvitation) => {
      const response = await friendApis.patch('/friend/invited/{id}/', {
        path: { id },
        body,
      });

      return response[200];
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['/friend/invited/']);
        queryClient.invalidateQueries(['/contact/']);
      },
    },
  );
};
